module.exports = __webpack_public_path__ + "files/f4e4df3b50e2e46951a121807128f021.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Exo-2-regular.woff2
 ** module id = 853
 ** module chunks = 0
 **/